/* Limite de caracteres para los inputs - se configura en el .env */
export const LIM_CUIT = parseInt(process.env.REACT_APP_LIM_CUIT);